<template>
  <div>
    <div v-if="loading">Загрузка...</div>
    <div v-else>
      <div>
        <span>Всего начислено: {{ inputBalance.toFixed(2) }} RUB</span>
        <span>Всего выплачено: {{ outputBalance.toFixed(2) }} RUB</span>
        <span>Баланс: {{ totalBalance.toFixed(2) }} RUB</span>
      </div>
      <el-input
        v-model="search"
        placeholder="Поиск..."
        size="normal"
        clearable
      ></el-input>
      <el-checkbox-group v-model="types">
        <el-checkbox label="input"></el-checkbox>
        <el-checkbox label="output"></el-checkbox>
      </el-checkbox-group>

      <virtual-list
        style="height: 300px;overflow-y: auto;"
        :data-key="'_id'"
        :data-sources="allHistory"
        :data-component="itemComponent"
      />
    </div>
  </div>
</template>
<script>
import { getUserBalanceHistory } from "@/api";
import HistoryItem from "./HistoryItem.vue";
import VirtualList from "vue-virtual-scroll-list";
export default {
  name: "BalanceHistoryComponent",
  components: {
    VirtualList
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    inputs: [],
    outputs: [],
    loading: false,
    types: ["input", "output"],
    search: "",
    itemComponent: HistoryItem
  }),
  computed: {
    allHistory() {
      return [
        ...this.inputs.map(inp => ({ ...inp, type: "input" })),
        ...this.outputs.map(out => ({
          ...out,
          balance: out.count,
          referalId: out.userId,
          type: "output"
        }))
      ]
        .filter(hist => this.types.includes(hist.type))
        .filter(
          hist =>
            hist._id.toLowerCase().includes(this.search.toLowerCase()) ||
            hist.balance
              .toString()
              .toLowerCase()
              .includes(this.search.toLowerCase())
        )
        .sort((a, b) =>
          a._id.localeCompare(b._id, "en", { sensitivity: "base" })
        )
        .map(
          (sum => hist => {
            const typeMult = hist.type === "input" ? 1 : -1;
            const statusMult =
              hist.status === 1 || hist.status === undefined ? 1 : 0;
            sum += typeMult * statusMult * hist.balance;
            return {
              ...hist,
              cumulative: sum
            };
          })(0)
        )
        .sort((a, b) =>
          b._id.localeCompare(a._id, "en", { sensitivity: "base" })
        );
    },
    inputBalance() {
      return this.inputs.reduce((prev, curr) => {
        return +curr.balance + prev;
      }, 0);
    },
    outputBalance() {
      return this.outputs
        .filter(out => out.status === 1)
        .reduce((prev, curr) => {
          return +curr.count + prev;
        }, 0);
    },
    totalBalance() {
      return this.inputBalance - this.outputBalance;
    }
  },
  methods: {
    async loadData() {
      if (!this.user || !this.user.id) return;
      try {
        this.loading = true;
        const { data } = await getUserBalanceHistory(this.user.id);
        this.inputs = data.result.inputs;
        this.outputs = data.result.outputs;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    }
  },
  async mounted() {
    await this.loadData();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Users/components/BalanceHistory/index.vue